
const saveDetails = (details) => {
    return {
        type: "SAVE_PERSON_RECORDS",
        item: details
    }
}


export {saveDetails}